import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';

import { BaseReportService, ButtonLoader } from '../../../../../core';
import { CurvaAbcVendaReportModal } from './curva-abc-venda-report-modal';
import { CurvaAbcVendaReportHttpService } from '../services';
import { CurvaAbcVendaFilter } from '../../filter';
import { CurvaAbcVendaPerspectiva } from '../../perspectiva';
import { take } from 'rxjs/operators';

@Component({
    selector: 'sgt-curva-abc-venda-report-modal',
    templateUrl: './curva-abc-venda-report-modal.component.html',
    styleUrls: ['./curva-abc-venda-report-modal.component.less']
})
export class CurvaAbcVendaReportModalComponent implements OnInit {
    elModal: any;
    @ViewChild('form') form: NgForm;
    entityModal: CurvaAbcVendaReportModal;

    constructor(private el: ElementRef,
                private baseReportService: BaseReportService,
                private curvaAbcVendaReportHttpService: CurvaAbcVendaReportHttpService) { }

    ngOnInit() {
        this.create();
    }

    /** Cria o modal */
    private create() {
        this.elModal = jQuery(this.el.nativeElement).find('.modal') as any;
        this.elModal
            .on('show.bs.modal', (e: any) => {
                e.stopPropagation();
            })
            .on('shown.bs.modal', (e: any) => {
                jQuery(this.elModal).find('#nomeImpressao').trigger('focus');
                e.stopPropagation();
            })
            .on('hide.bs.modal', (e: any) => {
                this.clear();
                e.stopPropagation();
            })
            .on('hidden.bs.modal', (e: any) => {
                e.stopPropagation();
            });
    }

    open(perspectiva: CurvaAbcVendaPerspectiva, filter: CurvaAbcVendaFilter, orderBy: number, orderByDir: string) {
        this.entityModal = new CurvaAbcVendaReportModal(perspectiva, filter, orderBy, orderByDir);
        this.elModal.modal({keyboard: false});
    }

    /** Realiza a impressão da consulta da Curva ABC de Vendas */
    print() {
        const btnPrint = new ButtonLoader('#btnPrint');
        btnPrint.loading('Imprimindo');
        this.curvaAbcVendaReportHttpService.print(this.entityModal?.perspectiva, this.entityModal?.filter, this.entityModal?.orderBy, this.entityModal?.orderByDir, this.entityModal?.nomeImpressao)
            .pipe(
                take(1)
            )
            .subscribe(
                pdf => {
                    btnPrint.reset();
                    this.baseReportService.open(pdf);
                    this.close();
                },
                error => {
                    btnPrint.reset();
                    this.baseReportService.openError(error);
                }
            );
    }

    private clear() {
        this.entityModal = null;
    }

    close() {
        this.elModal.modal('hide');
    }
}
